import { pushDatalayer } from '../utilities/datalayer';

document.querySelectorAll('[data-product-click]').forEach(item => {
    item.addEventListener('click', () => {
        let products = JSON.parse(item.dataset.datalayerItems);
        if (products && JSON.parse(item.dataset.product)) {
            products = products.filter((product) => product.item_id === JSON.parse(item.dataset.product)[0].id);
        }

        pushDatalayer({
            event: 'select_item',
            item_list_name: item.dataset.origin,
            ecommerce: {
                items: products && products.length === 1 ? products : null
            }
        });
    });
})
